import {store} from 'constants/store';
import {initArticles} from 'actions';

const bootstrap = (articles) => {
    store.dispatch(initArticles(articles));
}

export {bootstrap};